export default __webpack_public_path__ + "static/media/address_details_grey.5a726279.svg";